<app-slide id="affordabilitySlide" title="Affordability"
    supportingText="This is to help us find you a home you can afford to live in." [slideNumber]="slideNumber"
    [finalSlide]="finalSlide" [active]="active.active === 'affordability' && affordabilityDataLoaded"
    [slideCompleted]="formState.progress.affordabilityComplete">
    <div class="alert alert-danger" *ngIf="showError">
        {{errorMessage}}
    </div>

    <div id="affordability-error-summary" class="alert alert-danger" *ngIf="errors.length > 0 && showFormErrors">
        <p><strong>Errors found in form</strong></p>
        <p>There is a problem with the form, please check and correct the following, then try and submit it
            again.
        </p>
        <ul>
            <li *ngFor="let error of errors">
                <a (click)="scrollToId(error.name)" class="alert-link">{{error.title | titlecase}},
                    {{error.msg}}
                </a>
            </li>
        </ul>
    </div>

    <!-- <ng-container *ngIf="user | async as user"> -->
    <form [formGroup]="affordabilityForm" id="affordabilityForm" (submit)="onSubmit()" novalidate>
        <div class="section" id="affordability-income">
            <div class="row section__heading">
                <div class="col-sm-12">
                    <h2>Calculate your monthly household income</h2>
                </div>
            </div>
            <p>Which of the following are you in receipt of</p>
            <span class="form-group" *ngFor="let incomeControl of incomes.controls;">
                <button *ngIf="incomeControl.value.status === 'inactive'" class="btn btn-secondary btn-add_item"
                    (click)="add(incomeControl, 'incomes')" id="{{incomeControl.value.type}}_income_option">
                    <span><i class="glyphicon glyphicon-plus"></i></span>
                    {{ incomeControl.value.label }}
                </button>
            </span>
            <!--|| affordabilityForm.get(item.type)?.invalid && affordabilityForm.get(item.type)?.submitted  -->
            <br /><br />

            <div formArrayName="incomes" class="container-fluid payment-calc">
                <div *ngFor="let incomeControl of incomes.controls; let i = index" formGroupName="{{i}}">
                    <ng-container *ngIf="incomeControl.value.status === 'active'">
                        <div class="row payment-row"
                            [class.has-error]="(incomeControl.touched && incomeControl.invalid)">
                            <div class="col-md-3">
                                <div class="payment-item control-label">
                                    <strong>{{ incomeControl.value.label }}</strong>
                                </div>
                            </div>
                            <div class="col-md-7">
                                <div class="row">
                                    <div class="col-sm-4">
                                        <div class="form-group form-group--payment">
                                            <label class="pound"><span>£</span></label>
                                            <input type="text" number-validator step="0.01"
                                                id="{{incomeControl.value.type}}" class="form-control"
                                                placeholder="0.00" formControlName="amount" required />
                                            <div class="help-block"
                                                *ngIf="incomeControl.touched && incomeControl.get('amount')?.hasError('required')">
                                                Amount is required
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-8">
                                        <div class="form-group form-group--payment_period">
                                            <strong class="text">per&nbsp;</strong>
                                            <div class="btn-group toggle-buttons">
                                                <label class="btn btn-secondary"
                                                    [class.active]="incomeControl.value.frequency === 'week'">
                                                    Week
                                                    <input type="radio" class="sr-only" formControlName="frequency"
                                                        value="week" />
                                                </label>
                                                <label class="btn btn-secondary"
                                                    [class.active]="incomeControl.value.frequency === 'month'">
                                                    Month
                                                    <input type="radio" class="sr-only" formControlName="frequency"
                                                        autocomplete="off" value="month" />
                                                </label>
                                                <label class="btn btn-secondary"
                                                    [class.active]="incomeControl.value.frequency === 'year'">
                                                    Year
                                                    <input type="radio" class="sr-only" formControlName="frequency"
                                                        value="year" />
                                                </label>
                                            </div>
                                            <ng-container>
                                                <div class="help-block"
                                                    *ngIf="incomeControl.touched && incomeControl.get('frequency')?.hasError('required')">
                                                    Frequency is required
                                                </div>
                                            </ng-container>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <span class="remove_item text-success" (click)="remove(incomeControl)"
                                id="{{incomeControl.value.type}}_delete">
                                <i class="fa fa-times" aria-hidden="true"></i>
                            </span>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>

        <div class="section" id="affordability-outgoings">
            <div class="row section__heading">
                <div class="col-sm-12">
                    <h2>Calculate your monthly outgoings</h2>
                </div>
            </div>
            <p>Which of the following are you in receipt of</p>
            <span class="form-group" *ngFor="let outgoingControl of outgoings.controls;">
                <button *ngIf="outgoingControl.value.status === 'inactive'" class="btn btn-secondary btn-add_item"
                    (click)="add(outgoingControl, 'outgoings')" id="{{outgoingControl.value.type}}_income_option">
                    <span><i class="glyphicon glyphicon-plus"></i></span>
                    {{ outgoingControl.value.label }}
                </button>
            </span>
            <!--|| affordabilityForm.get(item.type)?.invalid && affordabilityForm.get(item.type)?.submitted  -->
            <br /><br />

            <div formArrayName="outgoings" class="container-fluid payment-calc">
                <div *ngFor="let outgoingControl of outgoings.controls; let i = index" formGroupName="{{i}}">
                    <ng-container *ngIf="outgoingControl.value.status === 'active'">
                        <div class="row payment-row"
                            [class.has-error]="(outgoingControl.touched && outgoingControl.invalid)">
                            <div class="col-md-3">
                                <div class="payment-item control-label">
                                    <strong>{{ outgoingControl.value.label }}</strong>
                                </div>
                            </div>
                            <div class="col-md-7">
                                <div class="row">
                                    <div class="col-sm-4">
                                        <div class="form-group form-group--payment">
                                            <label class="pound"><span>£</span></label>
                                            <input type="text" number-validator step="0.01"
                                                id="{{outgoingControl.value.type}}" class="form-control"
                                                placeholder="0.00" formControlName="amount" required />
                                            <div class="help-block"
                                                *ngIf="outgoingControl.touched && outgoingControl.get('amount')?.hasError('required')">
                                                Amount is required
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-8">
                                        <div class="form-group form-group--payment_period">
                                            <strong class="text">per&nbsp;</strong>
                                            <div class="btn-group toggle-buttons">
                                                <label class="btn btn-secondary"
                                                    [class.active]="outgoingControl.value.frequency === 'week'">
                                                    Week
                                                    <input type="radio" class="sr-only" formControlName="frequency"
                                                        value="week" />
                                                </label>
                                                <label class="btn btn-secondary"
                                                    [class.active]="outgoingControl.value.frequency === 'month'">
                                                    Month
                                                    <input type="radio" class="sr-only" formControlName="frequency"
                                                        autocomplete="off" value="month" />
                                                </label>
                                                <label class="btn btn-secondary"
                                                    [class.active]="outgoingControl.value.frequency === 'year'">
                                                    Year
                                                    <input type="radio" class="sr-only" formControlName="frequency"
                                                        value="year" />
                                                </label>
                                            </div>
                                            <ng-container>
                                                <div class="help-block"
                                                    *ngIf="outgoingControl.touched && outgoingControl.get('frequency')?.hasError('required')">
                                                    Frequency is required
                                                </div>
                                            </ng-container>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <span class="remove_item text-success" (click)="remove(outgoingControl)"
                                id="{{outgoingControl.value.type}}_delete">
                                <i class="fa fa-times" aria-hidden="true"></i>
                            </span>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
        <div class="section ng-empty">
            <div class="row">
                <div class="col-sm-8">
                    <div class="form-group ">
                        <button type="button" class="btn" style="position:relative;" (click)="onBack()">
                            <span>Back</span>
                        </button>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="form-group ">
                        <button type="submit" class="btn btn-primary" style="position: relative;"
                            [disabled]="isDisabled">
                            <span>Save &amp; Continue Securely</span>
                            <app-spinner *ngIf="submitting" class="applicationSubmitSpinner"></app-spinner>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <!-- </ng-container> -->
</app-slide>